import { Button, IPublicRestaurant, Label, StringUtils } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { GuestInfo, validateGuestInfo } from '../../../components';
import { IApplicationStore, IReservationPerson } from '../../../interfaces';
import { reservationActions } from '../../../store';

interface IActionProps {
    saveReservationPerson: typeof reservationActions.saveReservationPerson;
}

interface IStoreProps {
    reservationPerson: IReservationPerson;
}

interface IProps extends IActionProps, IStoreProps {
    restaurant: IPublicRestaurant;
    onNext: () => void;
    onBack: () => void;
}

const Person: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const getInitialPerson = (): IReservationPerson => {
        try {
            const savedPerson = localStorage.getItem('person');
            if (savedPerson) {
                const person = JSON.parse(savedPerson);
                if (typeof person.phoneNumber === 'string') {
                    person.phoneNumber = formatPhoneNumber(StringUtils.removeSpace(person.phoneNumber as string));
                }
                if (typeof person.email === 'string') {
                    person.email = StringUtils.removeSpace(person.email as string);
                }
                if (person.sendEmailReminder === undefined) {
                    person.sendEmailReminder = true;
                }
                return person;
            } else {
                return props.reservationPerson;
            }
        } catch (e) {
            return props.reservationPerson;
        }
    };

    const [person, setPerson] = React.useState<IReservationPerson>(getInitialPerson);
    const [website, setWebsite] = React.useState('');
    const isFormValid = validateGuestInfo(person, props.restaurant);

    const handlePersonChanges = (changes: any) => {
        setPerson(changes as IReservationPerson);
    };

    const handleBack = () => {
        props.onBack();
    };

    const handleNext = () => {
        props.saveReservationPerson({ ...person, website });
        localStorage.setItem('person', JSON.stringify(person));
        props.onNext();
    };

    return (
        <>
            <div className="widget-heading">
                <Label type="title" value={t('reservation.person.title')} variant="h5" />
                <p className="widget-lead">{t('reservation.person.lead')}</p>
            </div>
            <GuestInfo person={person} restaurant={props.restaurant} onPersonChanges={handlePersonChanges} />
            <input
                className="widget-extra-field"
                type="text"
                id="mylo-hp-field"
                name="mylo-hp-field"
                value={website}
                onChange={(event) => setWebsite(event.target.value)}
                tabIndex={-1}
                autoComplete="one-time-code"
                data-lpignore="true"
                data-1p-ignore="true"
                data-bwignore="true"
                data-form-type="other"
                aria-hidden="true"
            />
            <div className="grow" />
            <div className="buttons">
                <Button label={t('common.buttons.back')} secondary={true} onClick={handleBack} />
                <Button label={t('common.buttons.next')} disabled={!isFormValid} onClick={handleNext} />
            </div>
        </>
    );
};

const actions: IActionProps = {
    saveReservationPerson: reservationActions.saveReservationPerson,
};

const mapStateToProps = (state: IApplicationStore): IStoreProps => ({
    reservationPerson: state.reservation.person,
});

function formatPhoneNumber(phoneNumber = ''): string {
    if (phoneNumber.startsWith('00')) {
        phoneNumber = phoneNumber.replace('00', '+');
    }
    if (phoneNumber.startsWith('041')) {
        return phoneNumber.replace('041', '+41');
    }
    if (phoneNumber.startsWith('0')) {
        return phoneNumber.replace('0', '+41');
    }
    if (phoneNumber.startsWith('410')) {
        return phoneNumber.replace('410', '+41');
    }
    if (phoneNumber.startsWith('41')) {
        return phoneNumber.replace('41', '+41');
    }
    if (phoneNumber.startsWith('+41041')) {
        return phoneNumber.replace('+41041', '+41');
    }
    if (phoneNumber.startsWith('+410')) {
        return phoneNumber.replace('+410', '+41');
    }
    if (phoneNumber.startsWith('+')) {
        return phoneNumber;
    }
    return '+41' + phoneNumber;
}

export default connect(mapStateToProps, actions)(Person);
